import React, { useEffect } from "react";

import { priceFormat } from "utils/format";

import "./printAct.scss";
import Moment from "react-moment";


export const PrintAct = ({ returnRequest, setShowPrintAct }) => {

  useEffect(() => {
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        setShowPrintAct(false);
      }, 200);
    }, 200);
  }, []);

  return (
    <div className="printActReturnRequest">
      <table className="top">
        <tbody>
          <tr>
            <td>
              Заявка на возврат покупателя №{returnRequest?.returnRequest.number}
            </td>
            <td className="date" rowSpan={2}>
              <Moment format="DD.MM.YYYY">{returnRequest?.returnRequest.date}</Moment>
            </td>
          </tr>
          <tr>
            <td>
              Клиент: {returnRequest?.customer.name}
            </td>
          </tr>
        </tbody>
      </table>

      <div className="title">АКТ ВОЗВРАТА ТОВАРА</div>

      <table className="products">
        <tbody>
          <tr>
            <th>
              №
            </th>
            <th>
              Артикул
            </th>
            <th>
              Наименование
            </th>
            <th className="center">
              Кол-во
            </th>
            <th className="center">
              Сумма (общая)
            </th>
          </tr>

          {returnRequest?.products?.map(item =>
            <tr key={item.id}>
              <td>
                {item.index}
              </td>
              <td>
                {item.nomenclature?.article}
              </td>
              <td>
                {item.nomenclature?.name}
              </td>
              <td className="center">
                {item.count}
              </td>
              <td className="center">
                {priceFormat(item.sum)} р.
              </td>
            </tr>
          )}

        </tbody>
      </table>

      <table>
        <tbody>
          <tr>
            <td>
              Сдал (ФИО): ____________________________
            </td>
            <td>
              Получил (ФИО): _________________________
            </td>
          </tr>
          <tr>
            <td>
              Должность: _____________________________
            </td>
            <td>
              Должность: _____________________________
            </td>
          </tr>
          <tr>
            <td>
              М.П.
            </td>
            <td>
              М.П.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};